export default {"src":"/_next/static/media/gradient-1.f03414be.svg","height":451,"width":1103,"blurWidth":0,"blurHeight":0};